import { LockOutlined } from "@ant-design/icons";
import { Form, Input } from "antd";
import { isMaskedValue } from "common/Utility";
import SchemaFieldTitle from "../SchemaFieldTitle";
import Tooltip from "../Tooltip";

function FormStringField({ fieldErrors, fieldId, name, description, max, min, isRequired, disabled = false, ...field }) {
    const fieldValue = Form.useWatch([fieldId]);
    const isMasked = isMaskedValue(fieldValue);
    const isDisabled = disabled || (field.isPII && isMasked);

    return (
        <Form.Item
            key={fieldId}
            name={[fieldId]}
            label={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SchemaFieldTitle name={name} tags={field.classifiers} orientation="horizontal" tagSummary={false} isPrimaryKey={field.isPrimaryKey} />
                    {field.isPII && (
                        <Tooltip title="Masked data due to PII restriction">
                            <LockOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                        </Tooltip>
                    )}
                </div>
            }
            tooltip={description}
            validateFirst={true}
            rules={[
                {
                    required: isRequired,
                    message: `Value is required`,
                },
                {
                    type: "string",
                    min: min,
                    message: `Value should be minimum ${min} characters long`,
                },
                {
                    type: "string",
                    max: max,
                    message: `Value should be maximum ${max} characters long`,
                },
            ]}
            {...fieldErrors}
        >
            <Input disabled={isDisabled} placeholder={isMasked ? "Masked PII - Use 'Reveal' to edit" : undefined} />
        </Form.Item>
    );
}

export default FormStringField;
